var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"PartnerProfile"},[_c('iframe',{staticClass:"certificate-iframe",attrs:{"frameborder":"0","src":_vm.url}}),_c('div',{staticClass:"btn-container"},[_c('a',{staticClass:"download-btn",attrs:{"download":"Partner Certificate","href":_vm.url}},[_vm._v("Download")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }